import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import AddBoxIcon from '@material-ui/icons/AddBox';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardActionArea from "@material-ui/core/CardActionArea/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia/CardMedia";
import IconButton from "@material-ui/core/IconButton/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import ChooseProductDialog from "./ChooseProductDialog";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import {defaultVariabls} from "../../../../config";

class ProductChooser extends React.Component {
    classes = this.props.classes;
    state={
        pending: false,
        products: [],
    }
    componentDidMount(){
        this.setState({
            products:this.props.initial
        })
    }
    componentDidUpdate(newProps){
        if(newProps.initial !== this.props.initial){
            this.setState({
                products:this.props.initial
            })
        }
    }
    toggleOperation= () => {
        this.setState({
            pending:!this.state.pending,
        })
    }
    setProduct = async (data) => {
        let {products} = this.state;
        await products.push(data);
        await this.setState({
            products
        })
        await this.productsChanges();
        await this.toggleOperation();

    }
    async removeProduct(index) {
        let { products } = this.state;
        let temp =[];
        products.map(row =>{
            if(row.id !== index){
                temp.push(row)
            }
            return true
        });
        await this.setState({
            products: temp
        });
        this.productsChanges();
    }
    productsChanges(){
        let {products} = this.state;
        this.props.onChange(products)
    }
    render(){
        let {pending,products} = this.state;
        return(
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button
                            onClick={this.toggleOperation}
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<AddBoxIcon />}
                        >
                            {Translate.addProduct}
                        </Button>
                    </Grid>
                    {
                        products.length ? products.map((product,key) =>{
                            return(
                                <Grid  item xs={6} md={4}  key={key}>
                                    <Card style={{backgroundColor:"#f3f3f3"}}>
                                        <CardActionArea>
                                            <CardMedia
                                                component="img"
                                                alt="Default Product Image"
                                                height="180"
                                                image={
                                                    !!product.thumbnail.name ?
                                                        `${defaultVariabls.uploads}/FileManager/${product.thumbnail.name}_medium.${product.thumbnail.extension}`
                                                        :
                                                    product.thumbnail_medium
                                                }
                                            />
                                        </CardActionArea>
                                        <CardContent>
                                            <Typography>{product.name}</Typography>
                                            <Typography>{Translate.productCode}: <strong>{product.code}</strong></Typography>
                                            {
                                                !!product.target_link &&
                                                <Typography>
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        color="primary"
                                                        component="a"
                                                        target="_blank"
                                                        href={product.target_link}
                                                    >
                                                        {Translate.target_url_product}
                                                    </Button>
                                                </Typography>
                                            }

                                            <IconButton size="small" onClick={() => this.removeProduct(product.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }) : null
                    }
                </Grid>
                {
                    pending ? <ChooseProductDialog  cancleOperation={this.toggleOperation} setProduct={this.setProduct}/> : null
                }
            </React.Fragment>
        )
    }
}
export default withRouter(withSnackbar(withStyles(Styles)(ProductChooser)));